function generateRandomPassword(length = 12) {
  const charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789@#$!&*";
  let password = "";
  for (let i = 0; i < length; i++) {
    password += charset[Math.floor(Math.random() * charset.length)];
  }
  return password;
}

/**
 * Protects a given ExcelJS worksheet with a random password
 * @param {Worksheet} sheet - ExcelJS worksheet to protect
 * @param {number} passwordLength - Desired password length (default 12)
 * @returns {Promise<string>} - The randomly generated password
 */
export async function protectSheetWithRandomPassword(sheet, passwordLength = 12) {
  const password = generateRandomPassword(passwordLength);

  await sheet.protect(password, {
    selectLockedCells: true,
    selectUnlockedCells: true,
    formatCells: false,
    formatColumns: false,
    formatRows: false,
    insertColumns: false,
    insertRows: false,
    insertHyperlinks: false,
    deleteColumns: false,
    deleteRows: false,
    sort: false,
    autoFilter: false,
    pivotTables: false,
  });

  return password; // return if you want to log/store it
}
